<template>
  <div>
    <h2 class="iblock">
      {{ $t(title) }}
    </h2>
    <slot />
    <div class="iblock m-l-5" style="vertical-align: text-bottom">
      <span class="label label-primary" />
    </div>
    <span v-if="showDateRange" class="m-t-0 f-14 c-gray">
      <InputDateRange v-model:date-range="DateRangeComp" format="YYYY-MM" />
    </span>
    <!-- Custom Local Filter Options, Not Implemented -->

    <DataVisActiveFiltersList
      v-if="filters.length > 0"
      :filters="filters"
      @remove-filter="$emit('remove-filter', $event)"
    />
  </div>
</template>

<script>
import InputDateRange from '@/components/InputDateRange.vue'
import { PropDateRange } from '@/mixins/PropDateRangeMixin'
import DataVisActiveFiltersList from '@/components/DataVisActiveFiltersList.vue'

export default {
  name: 'DataVisHeader',
  components: {
    DataVisActiveFiltersList,
    InputDateRange,
  },
  mixins: [PropDateRange],
  props: {
    showDateRange: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    filters: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:DateRange', 'remove-filter'],
  computed: {
    DateRangeComp: {
      get() {
        return this.DateRange
      },
      set(range) {
        this.$emit('update:DateRange', range)
      },
    },
  },
}
</script>
